module.exports = __webpack_public_path__ + "img/ymhd_logo.468717dc.png";